'use client'

import { useGetDeliveryPurchaseItemMutation } from '@/queries/purchase/useGetDeliveryPurchaseItemMutation'
import { usePurchaseItemListMutation } from '@/queries/purchase/useGetPurchaseItemMutation'
import { purchaseItemStore } from '@/store/purchase-item.store'
import { useRouter, useSearchParams } from 'next/navigation'

export const usePurchaseInfo = () => {
  const searchParams = useSearchParams()
  const { mutateAsync: syncStorePurchaseItemList } = usePurchaseItemListMutation()
  const { mutateAsync: syncStorePurchaseDevliveryItem } = useGetDeliveryPurchaseItemMutation()
  const { purchaseItemList, deliveryPurchaseItem } = purchaseItemStore()
  const router = useRouter()

  const productCode = searchParams.get('productCode')
  const purchaseInfo = purchaseItemList.find((item) => item.productCode === productCode) ?? deliveryPurchaseItem

  const changePurchaseCard1 = ({ routerReplace } = { routerReplace: false }) => {
    const card1ProductCode = purchaseItemList.find((item) => item.cardCount === 1 && !item.free)?.productCode

    const href = `/purchase?productCode=${card1ProductCode}`

    routerReplace ? router.replace(href) : router.push(href)
  }

  const changePurchaseCard10 = ({ routerReplace } = { routerReplace: false }) => {
    const card10ProductCode = purchaseItemList.find((item) => item.cardCount === 10)?.productCode

    const href = `/purchase?productCode=${card10ProductCode}`

    routerReplace ? router.replace(href) : router.push(href)
  }

  const goToDeliveryPurchaseItem = async () => {
    const deliveryPurchaseItem = await syncStorePurchaseDevliveryItem()

    router.push(`/purchase?productCode=${deliveryPurchaseItem.productCode}`)
  }

  return {
    purchaseInfo,
    productCodeSearchParams: productCode,
    changePurchaseCard1,
    changePurchaseCard10,
    syncStorePurchaseItemList,
    syncStorePurchaseDevliveryItem,
    purchaseItemList,
    goToDeliveryPurchaseItem,
    deliveryPurchaseItem,
  }
}
